<!--
 * @Author: Huangxianlong
 * @Date: 2023-05-29 10:27:17
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2024-06-21 09:29:08
 * @FilePath: \monitor\src\App.vue
 * @Description: 
-->
<template>
  <div id="main" class="app-main">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isRouterAlive: true
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    sessionStorage.setItem("languageSet", serverConfig.language);
    console.log(serverConfig.language);
    if (serverConfig.language == "EN") {
      this.changeIco("EN");
    } else {
      this.changeIco("CN");
    }
    // 禁止页面缩放
    // window.addEventListener(
    //   "mousewheel",
    //   function(event) {
    //     if (event.ctrlKey === true || event.metaKey) {
    //       event.preventDefault();
    //     }
    //   },
    //   { passive: false }
    // );
    // //firefox
    // window.addEventListener(
    //   "DOMMouseScroll",
    //   function(event) {
    //     if (event.ctrlKey === true || event.metaKey) {
    //       event.preventDefault();
    //     }
    //   },
    //   { passive: false }
    // );
  },
  // 动态修改meta
  metaInfo() {
    return {
      title: this.$t("User.Meta.title"),
      meta: [
        {
          name: "keywords",
          content: this.$t("User.Meta.keywords")
        },
        {
          name: "description",
          content: this.$t("User.Meta.description")
        }
      ]
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    //修改Favicon的方法
    changeFavicon(link) {
      let $favicon = document.querySelector('link[rel="icon"]');
      if ($favicon !== null) {
        $favicon.href = link;
      } else {
        $favicon = document.createElement("link");
        $favicon.rel = "icon";
        $favicon.href = link;
        document.head.appendChild($favicon);
      }
    },
    //根据传递的参数修改Favicon
    changeIco(type) {
      // 得到图标地址
      let iconUrl;
      if (type == "EN") {
        iconUrl = `static/favicon_en.ico`;
      } else {
        iconUrl = `static/favicon.ico`;
      }
      this.changeFavicon(iconUrl);
    }
  }
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  overflow: auto;
}

.app-main {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue